"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInput = void 0;
const mithril_1 = require("../../mithril");
const image_button_1 = require("../button/image.button");
const icons_1 = require("../icon/icons");
const theme_1 = require("../theme");
const radio_input_style_1 = require("./radio.input.style");
(0, theme_1.addStyles)(radio_input_style_1.Style);
exports.RadioInput = {
    view(state) {
        const classList = [
            radio_input_style_1.CSS.container,
            `${radio_input_style_1.CSS.container}--${state.id}`,
            `${radio_input_style_1.CSS.container}--${state.label.toLowerCase()}`,
        ];
        if (state.disabled) {
            classList.push(radio_input_style_1.CSS.disabled);
        }
        const className = classList.join(' ');
        const onChange = (e) => exports.RadioInput.onChange(state);
        return (0, mithril_1.m)('div', { className, onclick: onChange }, [
            state.value ? image_button_1.ImageButton.view(icons_1.MaterialIcon.RADIO_SELECTED) : image_button_1.ImageButton.view(icons_1.MaterialIcon.RADIO),
            (0, mithril_1.m)('span', { className: radio_input_style_1.CSS.label }, state.label),
        ]);
    },
    onChange(state) {
        state.setValue(true);
    },
};
//# sourceMappingURL=radio.input.js.map